<template>
  <div class="side-right-bar">
    <!-- <div class="side-bar-nav">
      <div class="side-bar-nav-content">
        <el-popover
          class="popover-box"
          placement="right"
          :offset="50"
          width="2rem"
          popper-class="message-popover"
          trigger="hover"
        >
          <template #reference>
            <div
              class="content-view"
              @mouseover="isPhoneHover = true"
              @mouseout="isPhoneHover = false"
              :class="isPhoneHover ? 'highlightPhonefull' : 'highlightPhone'"
            ></div>
          </template>
          <template #default>
            <div
              class="content-tip-tips"
              style="
                font-family: PingFangSC-Regular;
                font-size: 0.0833rem;
                color: #393939;
                font-weight: 400;
                text-align: center;
              "
            >
              <a>预约申请</a>
            </div>
          </template>
          <div  @mouseover="isPhoneHover = true" @mouseout="isPhoneHover = false">
              <div class="content-tip-tips"  style="font-size:0.09rem;"><a>预约申请</a></div>
            </div>
        </el-popover>
      </div>
    </div> -->
    <el-backtop :right="20" :bottom="100" :visibility-height="700">
      <img
        style="width: 0.6944rem; height: 0.6944rem"
        src="../../assets/home/up-top@2x.png"
        alt=""
        srcset=""
      />
    </el-backtop>
  </div>
</template>
  
  <script setup lang="ts">
import { ref, Route } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const isPhoneHover = ref<boolean>(false);

const visible = ref(true);
const phoneTip = {
  tip1: "15872243992",
  tip2: "欢迎致电~",
};
const emailTip = {
  tip1: "欢迎添加微信咨询~",
};
const goSubscribe = () => {
  router.push({
    path: "/Subscribe",
  });
};
</script>
  
  <style lang="scss" scoped>
.back-top {
  width: 0.2778rem;
  height: 0.2778rem;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-size: 100% 100%;
  box-shadow: 0px 0.0139rem 0.1667rem 0px rgba(67, 102, 165, 0.18);
  line-height: 0.2778rem;
  color: #1989fa;
}

.side-bar-nav {
  position: fixed;
  width: 0.33rem;
  height: 0.33rem;
  top: 2.13rem;
  right: 0.117rem;
  z-index: 300;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0rem 0.0139rem 0.1667rem 0rem rgba(67, 102, 165, 0.18);
  .side-bar-nav-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    .content-view {
      width: 0.1111rem;
      height: 0.1111rem;
      margin: 0.0417rem 0;
      transition: transform 0.3s ease; /* 添加过渡效果 */
    }
    .content-tip-code {
      // width: 100%;
      display: flex;
      justify-self: center;
      text-align: center;
      margin: 0 auto;
      width: 0.7917rem;
      height: 0.7917rem;
    }
    .content-tip {
      height: 0.1736rem;
      font-family: PingFangSC-Semibold;
      font-size: 0.0833rem;
      color: #1978f0;
      font-weight: 600;
    }
    .content-tip1 {
      width: 0.9028rem;
      height: 0.1181rem;
      font-family: PingFangSC-Regular;
      font-size: 0.0833rem;
      color: #393939;
      font-weight: 400;
      z-index: 300;
    }
    .border-1 {
      margin: 0.0417rem 0;
      width: 0.1111rem;
      height: 0.0069rem;
      opacity: 0.35;
      border: 0.0069rem solid rgba(151, 151, 151, 1);
    }
    .highlightPhone {
      margin-top: 0.1389rem;
      background: url("../../assets/home-mobile/icon_subscribe@2x.png") center
        no-repeat;
      background-size: 100% 100%;
      transform: scale(1.2); /* 鼠标hover时放大1.2倍 */
    }
    .highlightPhonefull {
      margin-top: 0.1389rem;
      background: url("../../assets/home-mobile/icon_subscribe@3x.png") center
        no-repeat;
      background-size: 100% 100%;
      transform: scale(1.3); /* 鼠标hover时放大1.2倍 */
    }
  }
}
:deep(.el-popper) {
  min-width: 0px !important;
  font-size: 30px !important;
}
:deep(.el-backtop) {
  width: 0.2778rem !important;
  height: 0.2778rem !important;
}

@media (max-width: 980px) {
  // 小于等于980时
  .side-bar-nav {
    position: fixed;
    width: 1.4933rem;
    height: 1.5rem;
    top: 1rem;
    right: 0.2133rem;
    z-index: 300;
    // background-color: #fff;
    border-radius: 1.1667rem;
    box-shadow: 0rem 0.0139rem 0.1667rem 0rem rgba(67, 102, 165, 0.18);

    .side-bar-nav-content {
      justify-content: space-evenly;
      width: 100%;
      height: 100%;

      .content-view {
        padding: 0.2133rem;
        width: 1.0667rem;
        height: 1.0667rem;
      }

      //     .content-tip{
      //       height: .1736rem;
      //       font-family: PingFangSC-Semibold;
      //       font-size: .0833rem;
      //       color: #1978F0;
      //       font-weight: 600;
      //     }
      //     .content-tip1{
      //       width: .9028rem;
      //       height: .1181rem;
      //       font-family: PingFangSC-Regular;
      //       font-size: .0833rem;
      //       color: #393939;
      //       font-weight: 400;
      //       z-index:300;
      //     }
      .border-1 {
        width: 0.64rem;
      }
      .highlightPhone {
        margin-top: 0.1389rem;
        background: url("../../assets/home-mobile/icon_subscribe@2x.png") center
          no-repeat;
        background-size: 100% 100%;
        transform: scale(1); /* 鼠标hover时放大1.2倍 */
      }
      .highlightPhonefull {
        margin-top: 0.1389rem;
        background: url("../../assets/home-mobile/icon_subscribe@3x.png") center
          no-repeat;
        background-size: 100% 100%;
        transform: scale(1.1); /* 鼠标hover时放大1.2倍 */
      }
    }
  }
}
</style>
  
  <style lang="scss">
.message-popover {
  min-width: 0 !important;
  width: auto !important;
}
@media (max-width: 980px) {
  .message-popover {
    min-width: 0 !important;
    width: auto !important;
    padding: 0.3rem !important;
    .content-tip-code {
      // width: 100%;
      display: flex;
      justify-self: center;
      text-align: center;
      margin: 0 auto;
      width: 4.9rem;
      height: 4.9rem;
    }
    .content-tip-tips {
      text-align: center !important;
      font-size: 0.32rem !important;
      line-height: 0.45rem !important;
    }
  }
}
</style>
  